<div class="login-screen">
  <kui-modal
    *ngIf="showPasswordResetModal"
    [isOpen]="showPasswordResetModal"
    (isOpenChange)="isPasswordResetModalOpen()"
    type="info">
    <kp-modal-password-reset-required
      [email]="email.value"
      (closeClicked)="showPasswordResetModal = false"></kp-modal-password-reset-required>
  </kui-modal>

  <kui-modal
    *ngIf="showEmailVerificationModal"
    [isOpen]="showEmailVerificationModal"
    (isOpenChange)="isEmailVerificationModalOpen()"
    type="info">
    <kp-modal-email-verification-required
      [email]="email.value"
      (closeClicked)="showEmailVerificationModal = false"></kp-modal-email-verification-required>
  </kui-modal>

  <div class="login">
    <kp-login-header [skipAnimationIntro]="true"></kp-login-header>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
      <label class="email-input">
        <span class="form_label">Email</span>
        <div class="bottom-border">
          <input
            type="email"
            placeholder="Enter your email"
            required
            formControlName="email"
            name="email"
            id="email"
            (change)="emailChanged()"
            (input)="emailChanged()"
            [readonly]="showPasswordResetModal" />
        </div>
      </label>
      <label>
        <span class="form_label">Password</span>
        <div class="bottom-border password-container">
          <input
            class="input"
            type="password"
            placeholder="Enter your password"
            required
            formControlName="password"
            autocomplete="off"
            name="password"
            id="password"
            (change)="passwordChanged()"
            (input)="passwordChanged()"
            [type]="showPassword ? 'text' : 'password'"
            [readonly]="showPasswordResetModal" />
          <button
            class="toggle-show-password"
            (click)="toggleShowPassword($event)"
            type="button"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            <svg-icon
              [src]="
                showPassword ? '/assets/icons/icons-nav-visibility.svg' : '/assets/icons/icons-nav-visibility-off.svg'
              "></svg-icon>
          </button>
        </div>
      </label>
      <div class="form-actions">
        <p class="login-error" *ngIf="loginForm.valid && loginError">{{ loginErrorCopy }}</p>
        <button class="button button-pill" type="submit" [disabled]="!loginForm.valid || loginDisabled">Sign In</button>

        <div class="bottom-row">
          <kp-checkbox class="checkbox" [isChecked]="stayLoggedIn" (check)="loggedInCheckbox($event)">
            Stay Logged In
          </kp-checkbox>
          <a routerLink="/login/reset/code" class="forgot-password" (click)="sendCode()">Forgot password?</a>
        </div>
      </div>
    </form>
  </div>
</div>
